import React from 'react'
import classnames from 'classnames'
import { AnchorLink, ContentSummary, VideoSlider, Picture } from './index'

export const TopStories = ({
  title = '',
  content = {},
  videos = [],
  image = {},
  href = '#',
  hasMoreVideosTab = false,
  showFooter = false,
  className = ''
}) => {
  const allSources = [ {
    config: [ {
      combinerOptions: {
        w: 576,
        h: 324
      }
    } ]
  } ]
  
  const module = (
    <article className={classnames('sub-module', className, { 'top-stories has-media' : content.id })}>
      {
        title && <header><h1>{title}</h1></header>|| null
      }
      {
        videos.length ? <VideoSlider videos={videos} /> : 
        (
          image.url &&
          <div className="content">
            <figure className="feed-item-figure">
              <div className="img-wrap">
                <Picture thumbnail={ image.url } className="feed-item-figure" allSources={allSources} />
              </div>
            </figure>
          </div> || null
        )
      }
      {
        (content.date || content.headline) ? <ContentSummary {...content} /> : null
      }
      {
        (showFooter || !content.id) && (hasMoreVideosTab) &&
        <footer>
          <AnchorLink to={href} text="More Videos" />
        </footer>
      }
    </article>
  )

  return (videos.length || content.id) ? module : <article style={{ display: 'none' }} />

}

export default TopStories



// WEBPACK FOOTER //
// ../app/components/common/TopStories.jsx